import React from 'react';
import './RecipeOfTheDay.css';

import { useNavigate } from 'react-router-dom';
import { Banner } from '../interfaces/Banner.interface';

interface BannerProps {
  banner: Banner;
}
const RecipeOfTheDay: React.FC<BannerProps> = ({ banner }) => {

  const navigate = useNavigate();
  const handleViewRecipe = () => {
    navigate(`/receta/${banner.recetaId}`);
  };
  return (
    <div className="recipe-container" onClick={handleViewRecipe} style={{ backgroundImage: `url(${banner.urlImagenBanner})` }}>
    </div>
  );
};

export default RecipeOfTheDay;
